/// <amd-module name="Release/Landing/HubMessageBar/MessageActions" />
import * as React from "react";

import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";


export interface IMessagePayload {
    key: string;
    value: React.ReactNode;
}

export class MessageActions extends ActionsHubBase {
    public static getKey(): string {
        return "release-landing-message-bar-actions";
    }

    public initialize(): void {
        this._setMessage = new Action<IMessagePayload>();
    }

    public get setMessage(): Action<IMessagePayload> {
        return this._setMessage;
    }

    private _setMessage: Action<IMessagePayload>;
}
